import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mini-contacto',
  templateUrl: './mini-contacto.component.html',
  styleUrls: ['./mini-contacto.component.scss']
})
export class MiniContactoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
